var v1="<div class=\"lbaGrid_pagination clearfix\"> <ul class=\"pagination\"> <li ng-class=\"classPageMinRange\"> <a href ng-click=\"page.previous()\">&laquo;</a> </li> <li ng-repeat=\"numPage in rangePage\" ng-class=\"classNumPage(numPage)\"> <a href ng-click=\"page.get(numPage)\"> <span ng-bind=\"numPage\"></span>\n<span class=\"sr-only\" ng-if=\"classNumPage(numPage)\">(current)</span> </a> </li> <li ng-class=\"classPageMaxRange\"> <a href ng-click=\"page.remaining()\">&raquo;</a> </li> </ul> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("src/templates/gridPaginationTpl.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/templates/gridPaginationTpl.html
// module id = 505
// module chunks = 0